import { render, staticRenderFns } from "./HotelReleasedList.vue?vue&type=template&id=470cf3fb&scoped=true"
import script from "./HotelReleasedList.vue?vue&type=script&lang=js"
export * from "./HotelReleasedList.vue?vue&type=script&lang=js"
import style0 from "./HotelReleasedList.vue?vue&type=style&index=0&id=470cf3fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470cf3fb",
  null
  
)

export default component.exports